import { useEffect, useState } from "react";
import * as configUtils from "util/config";

export const useBeneficiaryDocumentCode = () => {
    const [beneficiariesDocumentCode, setBeneficiariesDocumentCode] = useState(null);

    useEffect(() => {
        const code = configUtils.get("onboarding.document.beneficiaries.code", "0012");
        setBeneficiariesDocumentCode(code);
    }, []);

    return { beneficiariesDocumentCode };
};

export default useBeneficiaryDocumentCode;
